export default class ContactForms {
	static init() {
		Array.prototype.forEach.call(document.querySelectorAll('.form'), form => {
			// Get honeypot field (hpField)
			const hpField = form.querySelector('input.hp')
			const submitButton = form.querySelector('button[type="submit"]')

			submitButton.addEventListener('click', () => {
				hpField.value = ''
			})
		})
	}
}
